import { render, staticRenderFns } from "./viewUser.vue?vue&type=template&id=59ecd06b&scoped=true"
import script from "./viewUser.vue?vue&type=script&lang=js"
export * from "./viewUser.vue?vue&type=script&lang=js"
import style0 from "./viewUser.vue?vue&type=style&index=0&id=59ecd06b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ecd06b",
  null
  
)

export default component.exports